import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'ase.list.title',
        defaultMessage: 'List documentations'
    },
    INTERNAL_TICKET_TITLE: {
        id: 'ase.list.titleInternalTicket',
        defaultMessage: 'List After Sales - Internal Ticket'
    },
    VISIBLE_COLUMNS: {
        id: 'ase.list.label.visibleColumns',
        defaultMessage: 'Visible columns'
    },
    TABLE_TICKET_NUMBER: {
        id: 'ase.list.table.ticketNo',
        defaultMessage: 'Ticket No.'
    },
    TABLE_SOLUTION_GROUP: {
        id: 'ase.list.table.solutionGroup',
        defaultMessage: 'Assigned SG'
    },
    TABLE_ORDER_CREATION_TIME: {
        id: 'ase.list.table.creationDate',
        defaultMessage: 'Creation Date'
    },
    TABLE_CLIENT_ID: {
        id: 'ase.list.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_NUMBER: {
        id: 'ase.list.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_REG_DIR: {
        id: 'ase.list.table.regDir',
        defaultMessage: 'Reg. Dir.'
    },
    TABLE_ISSUE_ORIGIN: {
        id: 'ase.list.table.issueOrigin',
        defaultMessage: 'Issue Origin'
    },
    TABLE_STATUS: {
        id: 'ase.list.table.status',
        defaultMessage: 'Status'
    },
    TABLE_LAST_STATUS_DATE: {
        id: 'ase.list.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_LAST_EDITOR: {
        id: 'ase.list.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
    TABLE_CREATED_BY: {
        id: 'ase.list.table.createdBy',
        defaultMessage: 'Created by (IPN)'
    },
    TABLE_INTERNAL_TICKET_NUMBER: {
        id: 'ase.internalList.table.ticketNo',
        defaultMessage: 'Internal Ticket No.'
    },
    TABLE_REQUEST_STATUS: {
        id: 'ase.internalList.table.requestStatus',
        defaultMessage: 'Request Status'
    },
    TABLE_DEALER_TICKET_NUMBER: {
        id: 'ase.internalList.table.dealerTicketNo',
        defaultMessage: 'Dealer Ticket No.'
    },
    TABLE_IT_CREATION_TIME: {
        id: 'ase.internalList.table.itCreationDate',
        defaultMessage: 'IT Creation Date'
    },
    TABLE_IT_ISSUE_ORIGIN: {
        id: 'ase.list.table.issueOrigin',
        defaultMessage: 'Issue Origin'
    },
    TABLE_IT_ISSUE_IDENTIFIED: {
        id: 'ase.list.table.issueIdentified',
        defaultMessage: 'Issue Identified'
    },
    TABLE_IT_PRIORITY: {
        id: 'ase.list.table.priority',
        defaultMessage: 'Priority'
    },
    TABLE_IT_CREATED_BY_IPN: {
        id: 'ase.list.table.createdByIpn',
        defaultMessage: 'Created by (IPN)'
    },
    TABLE_IT_LUP_QS_ASSOCIATED: {
        id: 'ase.list.table.lupQsAssociated',
        defaultMessage: 'Client risk'
    },
    TABLE_IT_DOCUMENTATION_UPDATE: {
        id: 'ase.list.table.documentationUpdate',
        defaultMessage: 'Documentation Update'
    },
    TABLE_SG_REQUESTOR: {
        id: 'ase.internalList.table.sgRequestor',
        defaultMessage: 'SG Requestor'
    },
    TABLE_ASSIGNED_SOLUTION_GROUP: {
        id: 'ase.internalList.table.assignedSolutionGroup',
        defaultMessage: 'Assigned SG'
    },
    TABLE_IT_LAST_STATUS_DATE: {
        id: 'ase.internalList.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_IT_LAST_EDITOR: {
        id: 'ase.internalList.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
});

export default messages;
